<template>
  <div class="deploy">
    <el-dialog
      :width="dialogWidth + 'px'"
      title="请输入访问密码"
      v-model="dialogFormVisible"
      custom-class="password-confirm-box"
    >
      <div class="publish-config-item">
        <span class="publish-config-item-label">密码</span>
        <span class="publish-config-item-input">
          <el-input
            autofocus
            spellcheck="false"
            v-model="publisVisitPassword"
            :type="isShowPassWord ? 'text' : 'password'"
          ></el-input>
        </span>
        <span class="toggle-show-my-password" @click="toggleShowPassword">
          <i :class="isShowPassWord ? 'el-icon-view' : 'iconfont icon-yanjing-guan'"></i>
        </span>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="testPassword">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <div class="loading-mask" v-if="isShowMask === true"></div>
    <screen :ProjectInfo="$store.state.ProjectInfo" @scene-switched="handleSceneSwitch"></screen>
  </div>
</template>

<script>
// @ is an alias to /src
import Screen from '@/views/commonviews/Screen.vue';
import { mapState } from 'vuex';
export default {
  name: 'Deploy',
  components: { Screen },
  data() {
    return {
      dialogFormVisible: false,
      isShowPassWord: false,
      publisVisitPassword: '',
      projectData: null,
      isShowMask: true,
      dialogWidth: 550,
      currentID: '',
    };
  },
  computed: {
    ...mapState({
      currentSceneId: state => state.currentSceneId, // 获取当前场景 ID
    }),
  },
  watch: {
    currentSceneId(newId) {
      console.log('Current scene ID changed to:', newId);
      this.currentID = newId;
    },
  },
  created() {
    this.isShowMask = true;
    this.$store.commit('setLoading', true);
    console.log(this.$store.state.ProjectInfo, '3534535353534');
    console.log(this.$store.state, 'currentID currentID');
    let cid = this.$store.state.currentSceneId;
    let pid = this.$router.currentRoute.value.query.pid;
    let sid = {
      pid,
      cid,
    };
    this.$store
      .dispatch('getProjectByPid', sid)
      .then(response => {
        console.log(response);
        this.projectData = response;
        document.title = this.projectData.project_name;
        if (this.projectData.is_use_publish_password !== '0') {
          this.dialogFormVisible = true;
          this.$store.commit('setLoading', false);
        } else {
          setTimeout(() => {
            this.isShowMask = false;
            this.$store.commit('setLoading', false);
          }, 1000);
        }
        this.setRatio();
      })
      .catch(err => {
        this.$ElMessage.error(`${err}`);
      });
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      setTimeout(() => {
        this.setRatio();
      }, 100);

      setTimeout(() => {
        this.$store.commit('setLoading', false);
      }, 1000);
    });
    this.screenMoveWidth();
  },

  methods: {
    screenMoveWidth() {
      let moveWidth = document.body.clientWidth;
      if (moveWidth <= 768) {
        let moWidth = moveWidth - 22;

        this.dialogWidth = moWidth;
      } else {
        this.dialogWidth = 550;
      }
    },
    handleSceneSwitch(infoID) {
      console.log('Scene switched with infoID:', infoID);
      // You can now use the infoID as needed in Deploy.vue
    },
    testPassword() {
      if (this.projectData.publish_password === this.publisVisitPassword) {
        this.$store.commit('setLoading', false);
        this.isShowMask = false;
        this.dialogFormVisible = false;
      } else {
        this.$ElMessage.error(`密码错误！`);
        this.dialogFormVisible = true;
      }
    },
    toggleShowPassword() {
      this.isShowPassWord = !this.isShowPassWord;
    },
    onResize() {
      this.setRatio();
    },
    setRatio() {
      let { clientWidth: c_width, clientHeight: c_height } = document.body;
      let { width: p_width, height: p_height } = this.$store.state.ProjectInfo.ScreenSize;
      let w_Ratio = Math.round((c_width / p_width) * 100);
      let h_Ratio = Math.round((c_height / p_height) * 100);
      this.$store.commit('set_ScreenRatio', {
        w_Ratio,
        h_Ratio,
      });
    },
    showLoading() {},
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.showLoading();
  },
};
</script>

<style lang="scss" scoped>
.deploy {
  height: 100vh;
  width: 100vw;
  position: relative;
  :deep().password-confirm-box {
    background-color: $background-color-medium;

    .publish-config-item {
      height: 30px;
      color: $font-color-base;
      margin-bottom: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-input {
        width: 254px;
      }
      .el-input input {
        height: 40px;
        color: #b6b8cc;
        background: #191b23;
        text-align: center;
        border: 1px solid rgba(139, 139, 139, 0.733);
        &:focus {
          border: 1px solid rgb(77, 91, 255);
        }
      }
      .publish-config-item-label {
        width: 70px;
        margin-right: 0px;
        text-align: center;
      }
      .copy-url-btn {
        margin-left: 10px;
      }
      .toggle-show-my-password {
        margin-left: 10px;
        cursor: pointer;
      }

      .publish-config-item-selector {
        .el-radio__input.is-checked {
          .el-radio__inner {
            background: #3a52c4;
            border: 1px solid #759efe;
            &::after {
              background: #3a52c4;
            }
          }
        }
        .el-radio__inner {
          background: #676767;
          border: 1px solid #676767;
          &::after {
            background: #676767;
          }
        }
      }
    }

    .el-dialog__header {
      display: flex;
      justify-content: center;
      .el-dialog__title {
        color: $font-color-base;
        //font-weight: bold;
        //letter-spacing: 2px;
        font-size: 20px;
      }
    }
    .el-dialog__footer {
      width: 100%;
      align-items: center;
      display: flex;
      text-align: center;
      .dialog-footer {
        width: 100%;
        .el-button {
          border: 0;
          margin: 0 10px;
          width: 110px;
          background: linear-gradient(143deg, #3651c5, #595dcb);
          color: #eae9e9;
          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            color: white;
          }
        }
      }
    }
  }
  .loading-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: $loading-mask-color;
    z-index: 999;
  }
  .screen {
    width: 100%;
    height: 100%;
  }
}
</style>
